import { useNavigate } from '@tanstack/react-router';
import { useDispatch } from 'react-redux';
import { rootApi } from 'store/root-api';
import cookie from 'utils/cookie';
import { firebaseLogout } from 'utils/firebase';
import { removeOtpTimestamps } from 'utils/otp-timestamps';
import { removeTokenFromStorage, setToken } from 'utils/token';
import { logoutZendesk } from 'utils/zendesk';

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return async () => {
    await logout();

    // Clear the RTK query cache
    dispatch(rootApi.util.resetApiState());
    navigate({ to: '/auth/login' });
  };
};

export async function logout() {
  cookie.removeAll();
  removeOtpTimestamps();
  logoutZendesk();
  removeTokenFromStorage();
  setToken(undefined);
  await firebaseLogout();
}

export default useLogout;
